import React, { useEffect } from "react";
import { Link } from "react-router-dom";

interface ServiceProps {
    data: any;
    isLoading: boolean;
}

const ProductCard: React.FC<ServiceProps> = (props) => {

    const linkUrl = props.data?.pageName === "catalog" || props.data?.pageName === "product" || props.data?.pageName === "announcements and news" || props.data?.pageName === "gallery"
        ? props.data?.url
        : props.data?.type === "gallery"
            ? `/galeri-liste/${props.data?.title}`
            : `/urun-detay/${props.data?._id}`;

    return (
        <>
            <div className="col-md-3">
                <div className="row columns_margin_bottom_40 services-row">
                    <div className="col-sm-8 col-xs-6">
                        <div className="teaser">
                            {/* main_bg_color2 size_normal round overlapped-icon*/}
                            <Link to={linkUrl} style={{ fontWeight: 800 }}>
                                <div className="">
                                    <img src={props.data?.icon} style={{ width: "80px", height: 80 }} ></img>
                                </div>
                                <h4 className="text-uppercase">
                                    <Link to={linkUrl} style={{ fontWeight: 800 }}> {props.data?.title} </Link>
                                </h4>
                                <hr className="divider_2_30 left main_bg_color" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductCard;